import React, { useState } from 'react'
import styles from './Login.module.scss'
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import logo from '../../imgs/logo.png'
import laptop from '../../imgs/laptop-login.png';
import laptopLight from '../../imgs/laptop-light.png';
import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@mui/material';
import LanguageButton from '../../components/LanguageButton';

export default function Login({setAccount,setBalance}) {
    const nav = useNavigate();
    const {t} = useTranslation();
    const [showPassword, setShowPassword] = useState(true);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [errorLogin, setErrorLogin] = useState(false);
    const [errorPassword, setErrorPassword] = useState(false);
    const [error, setError] = useState('');
    const [isLoading,setIsLoading] = useState(false);
    const handleLoginChange = (event) => {
        setError('')
        const value = event.target.value;
        setLogin(value);
        if (!value) {
            setErrorLogin(true);
        } else {
            setErrorLogin(false);
        }
    };
    const handlePasswordChange = (event) => {
        setError('')
        const value = event.target.value;
        setPassword(value);
        if (!value) {
            setErrorPassword(true);
        } else {
            setErrorPassword(false);
        }
    };
    const validateForm = () => {
        if (!login) setErrorLogin(true);
        if (!password) setErrorPassword(true);
        return !errorLogin && !errorPassword;
    };

    const handleSubmit = (event) => {
        console.log(validateForm())
        setIsLoading(true)
        if (validateForm()) {
            axios.post(process.env.REACT_APP_test_url + '/api/login', {
                Login: login,
                Password: password
            }).then((res) => {
                console.log(res);
                setAccount(res.data.account);
                setBalance(res.data.balance);
                secureLocalStorage.setItem("token", res.data.token);
                secureLocalStorage.setItem("user", res.data.user)
                secureLocalStorage.setItem('accounts',res.data.accounts);
                secureLocalStorage.setItem('selected_account',res.data.account);
                setTimeout(()=>{
                    nav('/cabinet', { replace: true });
                    setIsLoading(false)
                },200)
            }).catch((err) => {
                setError(err.response.data.message);
                setIsLoading(false)
            })
        }else{
            setIsLoading(false)
        }
    };
    const handleEnter = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleSubmit(event);
        }
    };

    return (
        <div className={styles.page}>
            <div className={styles.buttons}>
        <LanguageButton />
      </div>
            <div className={styles.login}>
                <div className={styles.login_form}>
                    <div className={styles.logo}>
                        <img loading="lazy" src={logo} alt="Logo" style={{ width: '60px' }} />
                        Trade Insiders
                    </div>
                    <div className={styles.body} onKeyDown={(event) => handleEnter(event)}>
                        <div className={styles.sign_in}>
                            <h1>{t("Sign in account")}</h1>
                            <p>{t("Enter your personal data")}</p>
                        </div>
                        <div className={styles.inputs}>
                            <div className={styles.Login}>
                                <label>{t("LoginAuth")}</label>
                                <input placeholder={t('LoginAuth')} onChange={e => handleLoginChange(e)} />
                                {errorLogin && (<span className={styles.errorLogin}>{t("Enter login please!")}</span>)}
                            </div>
                            <div className={styles.Password}>
                                <label>{t("Password")}</label>
                                <div className={styles.input_with_icon}>
                                    <input placeholder={t('Password')} type={showPassword ? 'password' : 'text'} onChange={e => handlePasswordChange(e)} />
                                        {
                                            !showPassword === false ?
                                                <span className={styles.icon} onClick={handleClickShowPassword}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={'1.7vh'} height={'1.7vh'} viewBox="0 0 17 17" fill="none">
                                                        <path d="M7.00016 8.40218C7.00016 7.57375 7.67174 6.90218 8.50016 6.90218C9.32859 6.90218 10.0002 7.57375 10.0002 8.40218C10.0002 9.23061 9.32859 9.90218 8.50016 9.90218C7.67174 9.90218 7.00016 9.23061 7.00016 8.40218Z" fill="#FCFCFC" />
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M1.8335 8.40218C1.8335 9.4951 2.11681 9.86316 2.68342 10.5993C3.81481 12.0691 5.71224 13.7355 8.50016 13.7355C11.2881 13.7355 13.1855 12.0691 14.3169 10.5993C14.8835 9.86316 15.1668 9.4951 15.1668 8.40218C15.1668 7.30926 14.8835 6.9412 14.3169 6.20507C13.1855 4.73522 11.2881 3.06885 8.50016 3.06885C5.71224 3.06885 3.81481 4.73522 2.68342 6.20507C2.11681 6.9412 1.8335 7.30926 1.8335 8.40218ZM8.50016 5.90218C7.11945 5.90218 6.00016 7.02147 6.00016 8.40218C6.00016 9.78289 7.11945 10.9022 8.50016 10.9022C9.88087 10.9022 11.0002 9.78289 11.0002 8.40218C11.0002 7.02147 9.88087 5.90218 8.50016 5.90218Z" fill="#FCFCFC" />
                                                    </svg>
                                                </span>
                                                : <span onClick={handleMouseDownPassword}  className={styles.icon}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={'1.7vh'} height={'1.7vh'} viewBox="0 0 16 16" fill="none">
                                                        <path d="M1.79258 4.46906C1.6838 4.21524 1.38986 4.09767 1.13605 4.20644C0.882233 4.31522 0.764657 4.60916 0.873435 4.86298L1.79258 4.46906ZM10.3911 8.88515L10.208 8.41989L10.208 8.41989L10.3911 8.88515ZM6.02731 9.15784C6.17791 8.92638 6.11237 8.61666 5.88091 8.46606C5.64945 8.31545 5.33973 8.381 5.18912 8.61246L6.02731 9.15784ZM4.24725 10.06C4.09664 10.2914 4.16219 10.6012 4.39365 10.7518C4.62511 10.9024 4.93483 10.8368 5.08543 10.6054L4.24725 10.06ZM15.1259 4.86298C15.2347 4.60916 15.1171 4.31522 14.8633 4.20644C14.6095 4.09767 14.3155 4.21524 14.2068 4.46906L15.1259 4.86298ZM12.6663 7.41857L12.3242 7.05401L12.3242 7.05401L12.6663 7.41857ZM13.3128 8.77213C13.5081 8.96739 13.8246 8.96739 14.0199 8.77213C14.2152 8.57687 14.2152 8.26028 14.0199 8.06502L13.3128 8.77213ZM7.49967 10.9993C7.49967 11.2755 7.72353 11.4993 7.99967 11.4993C8.27582 11.4993 8.49967 11.2755 8.49967 10.9993H7.49967ZM10.9139 10.6054C11.0645 10.8368 11.3742 10.9024 11.6057 10.7518C11.8372 10.6012 11.9027 10.2914 11.7521 10.06L10.9139 10.6054ZM3.68656 7.77213C3.88182 7.57687 3.88182 7.26028 3.68656 7.06502C3.4913 6.86976 3.17472 6.86976 2.97945 7.06502L3.68656 7.77213ZM1.97945 8.06502C1.78419 8.26028 1.78419 8.57687 1.97945 8.77213C2.17472 8.96739 2.4913 8.96739 2.68656 8.77213L1.97945 8.06502ZM7.99967 8.83268C5.85041 8.83268 4.30723 7.76242 3.28274 6.65912C2.77064 6.10764 2.39517 5.55457 2.14807 5.13944C2.0248 4.93235 1.93425 4.76089 1.87527 4.64293C1.8458 4.58399 1.82427 4.53851 1.81052 4.50876C1.80365 4.49388 1.79874 4.48295 1.79575 4.47624C1.79426 4.47288 1.79325 4.47058 1.79272 4.46937C1.79246 4.46877 1.79231 4.46843 1.79229 4.46838C1.79228 4.46835 1.7923 4.4684 1.79235 4.46851C1.79237 4.46856 1.79243 4.4687 1.79244 4.46873C1.79251 4.46888 1.79258 4.46906 1.33301 4.66602C0.873435 4.86298 0.873524 4.86318 0.873621 4.86341C0.873664 4.86351 0.873768 4.86375 0.873854 4.86395C0.874024 4.86434 0.874226 4.86481 0.874459 4.86535C0.874924 4.86643 0.875514 4.86779 0.87623 4.86943C0.87766 4.8727 0.879591 4.8771 0.882025 4.88257C0.886893 4.89352 0.893774 4.90878 0.902692 4.92809C0.920523 4.96669 0.946516 5.02148 0.980846 5.09014C1.04947 5.22739 1.15163 5.42052 1.28878 5.65092C1.56251 6.11079 1.97871 6.7244 2.54994 7.33957C3.69212 8.56961 5.48227 9.83268 7.99967 9.83268V8.83268ZM10.208 8.41989C9.56109 8.67452 8.82748 8.83268 7.99967 8.83268V9.83268C8.95848 9.83268 9.81606 9.64884 10.5743 9.35041L10.208 8.41989ZM5.18912 8.61246L4.24725 10.06L5.08543 10.6054L6.02731 9.15784L5.18912 8.61246ZM14.6663 4.66602C14.2068 4.46906 14.2068 4.46896 14.2069 4.46886C14.2069 4.46884 14.2069 4.46875 14.2069 4.4687C14.207 4.4686 14.207 4.46852 14.207 4.46847C14.2071 4.46836 14.2071 4.46834 14.207 4.46841C14.207 4.46855 14.2068 4.46903 14.2064 4.46985C14.2057 4.4715 14.2044 4.47451 14.2024 4.47884C14.1986 4.4875 14.1923 4.50141 14.1835 4.52018C14.166 4.55773 14.1387 4.61465 14.1014 4.68779C14.0268 4.83419 13.9124 5.04489 13.7566 5.29482C13.4443 5.79612 12.9705 6.44733 12.3242 7.05401L13.0085 7.78314C13.7346 7.10167 14.2608 6.3766 14.6054 5.82366C14.7781 5.54647 14.9064 5.31055 14.9923 5.14212C15.0352 5.05785 15.0677 4.9903 15.0899 4.94273C15.101 4.91894 15.1095 4.90013 15.1155 4.88671C15.1185 4.88 15.1208 4.87463 15.1226 4.87066C15.1235 4.86867 15.1242 4.86703 15.1247 4.86575C15.125 4.86511 15.1252 4.86456 15.1254 4.86409C15.1255 4.86386 15.1256 4.86365 15.1257 4.86347C15.1257 4.86337 15.1258 4.86325 15.1258 4.8632C15.1259 4.86309 15.1259 4.86298 14.6663 4.66602ZM12.3242 7.05401C11.7515 7.59151 11.0489 8.0889 10.208 8.41989L10.5743 9.35041C11.5567 8.96372 12.3641 8.38803 13.0085 7.78314L12.3242 7.05401ZM12.3128 7.77213L13.3128 8.77213L14.0199 8.06502L13.0199 7.06502L12.3128 7.77213ZM7.49967 9.33268V10.9993H8.49967V9.33268H7.49967ZM9.97204 9.15784L10.9139 10.6054L11.7521 10.06L10.8102 8.61246L9.97204 9.15784ZM2.97945 7.06502L1.97945 8.06502L2.68656 8.77213L3.68656 7.77213L2.97945 7.06502Z" fill="#A0A0AB" />
                                                    </svg>
                                                </span>
                                        }
                                </div>
                                {errorPassword && (<span className={styles.errorPassword}>{t("Enter password please!")}</span>)}
                            </div>
                        </div>
                        <div className={login && password ? styles.Button : styles.DisableButton}>
                            <button onClick={handleSubmit}>{isLoading?<CircularProgress color='white' size="25px"/>:t("Login")}</button>
                        </div>
                        {error && (
                            <div className={styles.Error}>
                                <div className={styles.errorText}>{error}</div>
                            </div>
                        )}
                    </div>
                    <div className={styles.Register}>
                        <p>{t("No account?")}</p>
                        <Link to={'/register'}>{t("Sign up")}</Link>
                    </div>
                </div>
                <div className={styles.bg_laptop}>
                    {secureLocalStorage.getItem('data-theme') === 'dark'?
                    <img loading="lazy" src={laptop} alt='laptop' width={'100%'} height={'100%'} />:
                    <img loading="lazy" src={laptopLight} alt='laptop' width={'100%'} height={'100%'} />}
                </div>
            </div>
        </div>
    )
}
